<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <custom-data-table :tableName="tableName" :header="headers" :items="items" :visibleCreate="true" :loading="loading"
        @stored="stored" :visibleStore="updatePermission" :selectLabel="selectLabel" :selectItems="selectItems" @selected="selected" :visibleSelect="true">
          <template v-slot:button>
            <v-btn v-if="categoryDisplayPermission" class="mr-2" depressed small color="success" :to="{ name: 'CategoryMaster' }" >カテゴリ情報</v-btn>
          </template>
          <template v-slot:action="{ item }">
              <v-btn v-if="updatePermission" class="mr-2" depressed small @click.stop="updated(item)" color="primary">編集</v-btn>
              <v-btn v-if="deletePermission" class="mr-2" depressed small @click.stop="deleted(item)" color="error">削除</v-btn>
          </template>
        </custom-data-table>
      </v-col>
    </v-row>
    <!-- 削除ボタン押下後に表示されるダイアログ -->
    <v-row justify="center">
      <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleDelete
        @deleted="submit" @canceled="dialogCancel"/>
    </v-row>
  </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import statusList from "@/helpers/const";
  import CalcCommon from "@/helpers/calcCommon";
  import ExpenseApi from "@/api/expense-api";
  import ExpenseRefineApi from "@/api/expense-refine-api";
  import CustomDataTable from "@/components/custom_ui/CustomDataTable";
  import CustomDialog from "@/components/custom_ui/CustomDialog";

  export default {
    name: "ExpenseMaster",
    components: {
      CustomDataTable,
      CustomDialog
    },
    props: ["user"],
    data: () => ({
      // 共通コンポーネント: データテーブル関連
      loading: false,
      tableName: '費目情報',
      headers: [
        { text: 'カテゴリ', value: 'category', sortable: false},
        { text: '費目名称', value: 'expense_name', sortable: false},
        { text: '規格等', value: 'standard', sortable: false},
        { text: '単位', value: 'display_unit', sortable: false},
        { text: '歩掛', value: 'percentage', sortable: false, align: 'end'},
        { text: '単価', value: 'unit_price', sortable: false, align: 'end'},
        { text: '集計費目', value: 'aggregate', sortable: false},
        { text: 'アクション', value: 'action', sortable: false},
      ],
      items: [],

      // カテゴリセレクト
      category_id: '0',
      selectLabel: 'カテゴリ',
      selectItems: [],

      // 削除ダイアログ
      dialogMaxWith: 500,
      dialogTitle: '',
      dialogItems: [],
      dialogDrawer: false,
      deleteId: null,

      // 権限
      categoryDisplayPermission: true,
      updatePermission: true,
      deletePermission: true
    }),
    created () {
      this.initialize ();
    },
    methods: {
      isLoading() {
        this.loading = !this.loading;
        this.$emit("loading", this.loading);
      },
      initialize () {
        this.isLoading();
        if (this.user.role_id == 0) {
          this.updatePermission = this.user.permission_config.CTSG00007.update;
          this.deletePermission = this.user.permission_config.CTSG00007.delete;

          if ('CTSG00014' in this.user.permission_config) {
            this.categoryDisplayPermission = this.user.permission_config.CTSG00014.read;
          }
        }
        this.expenseApi = new ExpenseApi();
        this.expenseRefineApi = new ExpenseRefineApi();
        const promise = this.expenseRefineApi.list(this.category_id);
        promise.then((response) => {
          this.selectItems = response.data.body.category_list;
          this.items = response.data.body.expense_refine_list;
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.$emit('logoutConform');
            } else if (error.response.data.status == statusList.status.entityError) {
              this.$emit("error",error.response.data.message);
              this.$router.push({ name: "Dashboard" })
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
            this.isLoading();
        });
      },
      // カテゴリ選択時のイベント
      selected (item) {
        this.isLoading();
        const promise = this.expenseRefineApi.list(item.id);
        promise.then((response) => {
          this.items = response.data.body.expense_refine_list;
          for (var item of this.items) {
            item.unit_price = CalcCommon.addFigure(item.unit_price);
          }
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.$emit('logoutConform');
            } else if (error.response.data.status == statusList.status.entityError) {
              this.$emit("error",error.response.data.message);
              this.$router.push({ name: "Dashboard" })
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
            this.isLoading();
        });
      },
      // 新規作成ボタン押下時のイベント
      stored () {
        this.$router.push({ name: 'CreateExpenseMaster' });
      },
      // 編集ボタン押下時イベント
      updated (item) {
        this.$router.push({ name: 'EditExpenseMaster', params: { id: item.id } });
      },
      // 削除ボタン押下時イベント
      deleted (item) {
        this.deleteId = item.id;
        this.dialogTitle = '削除しますか？';
        this.dialogItems = [
          { name: "費目名称", value: item.expense_name },
          { name: "規格等", value: item.standard },
          { name: "単位", value: item.display_unit },
          { name: "歩掛", value: item.percentage },
          { name: "単価", value: item.unit_price }
        ];
        this.dialogDrawer = true;
      },
      dialogCancel () {
        this.dialogDrawer = false;
      },
      // ダイアログ削除ボタン押下時イベント
      submit() {
        this.isLoading();
        // 費目IDを選択済みアイテム情報から取得
        const promise = this.expenseApi.delete(this.deleteId);
        promise.then((response) => {
            this.items = this.items.filter((item) => {
              return (item.id !== this.deleteId);
            });
            this.deleteId = null;
            this.dialogDrawer = false;
            this.$emit('success', response.data.message);
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.dialogDrawer = false;
              this.$emit('logoutConform');
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      }
    },
  };
</script>
